(function () {
  if (window.__clozsHeaderLoaded) return;
  window.__clozsHeaderLoaded = true;

  var isHome = document.body && document.body.classList.contains('template-index');
  var root = document.documentElement;
  var body = document.body;
  var scrollThreshold = 40;
  var transparentHeroOnly = true;
  var ticking = false;
  var heroSection = null;
  var transparentEligible = false;
  var heroTone = 'light';
  var revealObserver = null;

  var heroSelectors = [
    '[class*="clozs-hero-"]',
    '[class*="lux-hero-"]',
    '.slideshow',
    '.banner',
    '.banner--overlay',
    '.banner--reveal',
    '.video-hero',
    '.image-banner',
    '.collection-hero'
  ].join(', ');

  function getHeader() {
    return document.getElementById('shopify-section-header');
  }

  function readHeaderSettings() {
    var header = getHeader();
    var settings = header && header.querySelector('[data-clozs-header-settings]');
    var threshold = settings ? parseInt(settings.getAttribute('data-clozs-scroll-threshold'), 10) : NaN;

    if (!Number.isNaN(threshold)) {
      scrollThreshold = Math.max(0, threshold);
    }

    transparentHeroOnly = !settings || settings.getAttribute('data-clozs-transparent-hero-only') !== 'false';
  }

  function isVisibleSection(node) {
    if (!node || node.hidden) return false;
    if (node.getAttribute('aria-hidden') === 'true') return false;

    var rect = node.getBoundingClientRect();
    return rect.height > 120 && rect.width > 0;
  }

  function resolveHeroSection() {
    if (!isHome) return null;

    var main = document.getElementById('MainContent');
    if (!main) return null;

    var sections = Array.prototype.slice.call(main.children);
    for (var i = 0; i < sections.length; i += 1) {
      var section = sections[i];
      if (!isVisibleSection(section)) continue;
      if (section.matches(heroSelectors) || section.querySelector(heroSelectors)) {
        return section;
      }
    }

    return null;
  }

  function syncHeroOverlap() {
    if (heroSection && heroSection.classList) {
      heroSection.classList.remove('clozs-hero-under-header');
    }

    heroSection = resolveHeroSection();
    transparentEligible = Boolean(heroSection) || (isHome && !transparentHeroOnly);
    var toneNode = heroSection && heroSection.dataset && heroSection.dataset.clozsHeaderTone
      ? heroSection
      : heroSection && heroSection.querySelector('[data-clozs-header-tone]');
    heroTone = toneNode && toneNode.dataset && toneNode.dataset.clozsHeaderTone === 'dark' ? 'dark' : 'light';

    body.classList.toggle('clozs-header-over-hero', transparentEligible);
    body.classList.toggle('clozs-header-solid-home', isHome && !transparentEligible);
    body.classList.toggle('clozs-hero-tone-dark', transparentEligible && heroTone === 'dark');
    body.classList.toggle('clozs-hero-tone-light', transparentEligible && heroTone !== 'dark');

    if (heroSection && heroSection.classList) {
      heroSection.classList.add('clozs-hero-under-header');
    }
  }

  function setMeasurements() {
    var header = getHeader();
    var announcement = document.getElementById('shopify-section-announcement-bar');
    var headerHeight = header ? Math.round(header.getBoundingClientRect().height) : 0;
    var announcementHeight = announcement ? Math.round(announcement.getBoundingClientRect().height) : 0;

    root.style.setProperty('--clozs-header-height', headerHeight + 'px');
    root.style.setProperty('--clozs-announcement-height', announcementHeight + 'px');
  }

  function updateState() {
    var header = getHeader();
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    var doc = document.documentElement;
    var max = Math.max(1, doc.scrollHeight - window.innerHeight);
    var progress = Math.min(1, Math.max(0, scrollTop / max));
    var heroProgress = 0;
    var canBeTransparent = isHome && transparentEligible;
    var scrolled = !canBeTransparent || scrollTop >= scrollThreshold;
    var headerBlend = scrolled ? 1 : 0;

    if (canBeTransparent && heroSection) {
      var heroRect = heroSection.getBoundingClientRect();
      heroProgress = Math.min(1, Math.max(0, -heroRect.top / Math.max(1, heroRect.height)));
    }

    root.style.setProperty('--clozs-scroll-progress', progress);
    root.style.setProperty('--clozs-header-blend', headerBlend.toFixed(3));
    root.style.setProperty('--clozs-hero-progress', heroProgress.toFixed(3));
    root.style.setProperty('--clozs-hero-media-scale', (1 + heroProgress * 0.045).toFixed(4));
    root.style.setProperty('--clozs-hero-media-y', Math.round(heroProgress * 28) + 'px');
    root.style.setProperty('--clozs-hero-content-y', Math.round(heroProgress * -18) + 'px');
    root.style.setProperty('--clozs-hero-content-opacity', (1 - heroProgress * 0.18).toFixed(3));

    if (canBeTransparent) {
      body.classList.toggle('clozs-at-top', !scrolled);
      body.classList.toggle('clozs-scrolled', scrolled);
    } else {
      body.classList.remove('clozs-at-top');
      body.classList.add('clozs-scrolled');
    }

    if (header) {
      header.classList.toggle('is-transparent', canBeTransparent && !scrolled);
      header.classList.toggle('is-scrolled', scrolled);
      header.classList.toggle('is-solid-default', !canBeTransparent);
      header.classList.toggle('header--overlay', canBeTransparent && !scrolled);
      header.classList.toggle('header--solid', scrolled || !canBeTransparent);
      header.classList.toggle('is-home-hero', canBeTransparent);
    }
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;

    window.requestAnimationFrame(function () {
      ticking = false;
      setMeasurements();
      updateState();
    });
  }

  function closeMenu(menu) {
    if (!menu) return;
    window.clearTimeout(menu.__clozsCloseTimer);

    if (typeof menu.close === 'function') {
      menu.close();
    } else {
      menu.classList.remove('is-active');
    }

    setExpanded(menu, false);
  }

  function setExpanded(menu, expanded) {
    var trigger = menu.querySelector('.header__menu-item--top, .header__menu-item');
    if (!trigger) return;

    trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function openMenu(menu) {
    if (!menu) return;
    window.clearTimeout(menu.__clozsCloseTimer);

    if (typeof menu.handleMouseover === 'function') {
      menu.handleMouseover();
    } else {
      menu.classList.add('is-active');
    }

    setExpanded(menu, true);
  }

  function scheduleClose(menu) {
    window.clearTimeout(menu.__clozsCloseTimer);
    menu.__clozsCloseTimer = window.setTimeout(function () {
      if (menu.matches(':hover') || menu.contains(document.activeElement)) return;
      closeMenu(menu);
    }, 180);
  }

  function enhanceDropdowns() {
    document.querySelectorAll('#shopify-section-header dropdown-menu, #shopify-section-header mega-menu').forEach(function (menu) {
      if (menu.dataset.clozsEnhanced === 'true') return;
      menu.dataset.clozsEnhanced = 'true';

      var trigger = menu.querySelector('.header__menu-item--top, .header__menu-item');
      var panel = menu.querySelector('.list-menu-dropdown');

      if (trigger) {
        trigger.setAttribute('aria-haspopup', panel ? 'true' : 'false');
        trigger.setAttribute('aria-expanded', 'false');
      }

      menu.addEventListener('mouseenter', function () {
        openMenu(menu);
      });

      menu.addEventListener('mouseleave', function () {
        scheduleClose(menu);
      });

      menu.addEventListener('focusin', function () {
        openMenu(menu);
      });

      menu.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (!menu.contains(document.activeElement)) scheduleClose(menu);
        }, 0);
      });

      menu.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        closeMenu(menu);
        if (trigger) trigger.focus({ preventScroll: true });
      });
    });
  }

  function closeLanguageMenus(exceptMenu) {
    document.querySelectorAll('[data-clozs-language-disclosure][open]').forEach(function (menu) {
      if (menu !== exceptMenu) menu.removeAttribute('open');
    });
  }

  function enhanceScrollReveals() {
    if (!isHome || revealObserver || !('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var main = document.getElementById('MainContent');
    if (!main) return;

    var sections = Array.prototype.slice.call(main.children).filter(function (section) {
      return section !== heroSection && isVisibleSection(section);
    });

    if (!sections.length) return;

    body.classList.add('clozs-reveal-enabled');

    revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in-view');
        revealObserver.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.12
    });

    sections.forEach(function (section, index) {
      section.classList.add('clozs-scroll-reveal');
      section.style.setProperty('--clozs-reveal-delay', Math.min(index, 5) * 45 + 'ms');
      revealObserver.observe(section);
    });
  }

  function enhanceLanguageSwitchers() {
    document.querySelectorAll('[data-clozs-language-disclosure]').forEach(function (menu) {
      if (menu.dataset.clozsEnhanced === 'true') return;
      menu.dataset.clozsEnhanced = 'true';

      menu.addEventListener('toggle', function () {
        if (menu.open) closeLanguageMenus(menu);
      });
    });
  }

  function closeAllMenus() {
    document.querySelectorAll('#shopify-section-header dropdown-menu.is-active, #shopify-section-header mega-menu.is-active').forEach(closeMenu);
    closeLanguageMenus();
  }

  function init() {
    readHeaderSettings();
    syncHeroOverlap();
    setMeasurements();
    enhanceDropdowns();
    enhanceLanguageSwitchers();
    enhanceScrollReveals();
    updateState();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    document.addEventListener('shopify:section:load', function () {
      readHeaderSettings();
      syncHeroOverlap();
      enhanceDropdowns();
      enhanceLanguageSwitchers();
      requestUpdate();
    });
    document.addEventListener('shopify:section:unload', function () {
      syncHeroOverlap();
      requestUpdate();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAllMenus();
    });
    document.addEventListener('click', function (event) {
      var languageOption = event.target.closest('[data-clozs-language-option]');
      if (languageOption) {
        var form = languageOption.closest('form');
        var input = form && form.querySelector('[data-clozs-language-input]');

        event.preventDefault();

        if (input) input.value = languageOption.getAttribute('data-clozs-language-option');
        if (form) form.submit();
        return;
      }

      if (!event.target.closest('[data-clozs-language-disclosure]')) {
        closeLanguageMenus();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
